export default "__VITE_ASSET__DO7zocVu__"